// src/components/Layout/VoiceBotFooter.js (updated)
import React, { useEffect, useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useStaticTranslations } from "../../utils/staticTranslations";

const VoiceBotFooter = ({ config }) => {
  const [color, setColor] = useState("");
  const { currentLanguage } = useLanguage();
  const { commonMessage } = useStaticTranslations(currentLanguage.code);
  
  useEffect(() => {
    const storedData = localStorage.getItem("chatBotData");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setColor(parsedData.color);
    }
  }, []);
  
  return (
    <>
      <div className="p-2 bg-white text-gray-400 text-center text-xs rounded-b-lg">
        {commonMessage('poweredBy')}{" "}
        <span style={{ color: color }}>{`${config.name} `}</span>
      </div>
    </>
  );
};

export default VoiceBotFooter;